import { render, staticRenderFns } from "./StepCollaboration.vue?vue&type=template&id=4bf57a9a&scoped=true"
import script from "./StepCollaboration.vue?vue&type=script&lang=js"
export * from "./StepCollaboration.vue?vue&type=script&lang=js"
import style0 from "./css/stepCollaboraron.css?vue&type=style&index=0&id=4bf57a9a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf57a9a",
  null
  
)

export default component.exports